import { Pipe, PipeTransform } from '@angular/core';

import { getDevicesFieldsWidth } from '../../enclosure/helpers/product.helper';
import { IProduct } from '../../shared/models/product.model';

@Pipe({
    name: 'deviceSlotNumber',
    standalone: false
})
export class DeviceSlotNumberPipe implements PipeTransform {

  transform(device: IProduct): number {
    return getDevicesFieldsWidth(device);
  }

}
